module.exports = __webpack_public_path__ + "images/wxwork/ic-wcwf-2-452abd18dac05b25b11e3b5cf2d52a5d.png";